export default {"src":"/_next/static/media/password.8b127325.svg","height":610,"width":702};